module.exports = __webpack_public_path__ + "img/environment2.0b5206ea.png";